<template lang="pug">
.container
  .product-reviews-bazaarvoice
    .tabs
      a( href="" :class="{ active: tab === 'reviews' }" @click.prevent="tab='reviews'" ) Reviews
      a( href="" :class="{ active: tab === 'questions' }" @click.prevent="tab='questions'") Questions & Answers
    .content
      .content-page( :class="{ active: tab == 'reviews' }" )
        div( data-bv-show="reviews" :data-bv-product-id="product" )
      .content-page( :class="{ active: tab == 'questions' }" )
        div( data-bv-show="questions" :data-bv-product-id="product" )
</template>

<script>
  export default {
    name: 'ProductReviews',
    components: {
    },
    props: {
      product: Number,
    },
    data() {
      return {
        tab: 'reviews'
      };
    }
  };
</script>

<style scoped lang="scss">
.product-reviews-bazaarvoice {
  .tabs {
    margin: 20px 0;
    background: $color-grey-100;
    display: flex;
    justify-content: center;
    a {
      border-top: 5px solid $color-grey-100;
      margin: 20px 5px 0 5px;
      background: #f8f8f8;
      color: $color-grey-700;
      padding: 15px 50px;
      text-decoration: none;
      font-weight: bold;
    }
    a.active {
      border-top: 5px solid $color-grey-500;
      background: $color-white;
      color: $color-black;
    }
  }
  .content-page { display: none; }
  .content-page.active { display: block; }
}
</style>

